import {
  useGetSingleItemName,
  useGetMerchantOrderId,
  useGetAdvancedCartDetails,
  useGetCartTypeToggle,
  useGetCart,
  useIsCartOverBooked,
  useSingleLenderCartAmountError,
} from '../services/cartManager';
import { useGetMerchantConfigurationOptions } from '../services/configManager';
import {
  useGetApprovedAmount,
  useGetCheckoutMinimumAmount,
} from '../services/flowManager';
import { isCartValid } from '../validations';

export const useIsCartInvalid = () => {
  const singleItemName = useGetSingleItemName();
  const merchantOrderId = useGetMerchantOrderId();
  const { merchantOrderIdRequired } = useGetMerchantConfigurationOptions();
  const advancedCartDetails = useGetAdvancedCartDetails();
  const cartTypeToggle = useGetCartTypeToggle();
  const cartTotal = useGetCart();
  const overBooked = useIsCartOverBooked();
  const approvedAmount = useGetApprovedAmount();
  const minimumAmount = useGetCheckoutMinimumAmount();
  const singleLenderCartAmountError = useSingleLenderCartAmountError();

  const cartOutOfRange =
    cartTotal.totalAmount <= 0 ||
    (!!approvedAmount && !!overBooked) ||
    (!!minimumAmount && cartTotal.totalAmount < minimumAmount) ||
    !!singleLenderCartAmountError;

  const isInvalid =
    cartOutOfRange ||
    (cartTypeToggle
      ? !isCartValid({
          merchantOrderId: advancedCartDetails.merchantOrderId,
          merchantOrderIdRequired,
        })
      : !isCartValid({
          singleItemName,
          merchantOrderId,
          merchantOrderIdRequired,
        }));

  return isInvalid;
};
